import React, { useState, useRef, useEffect } from 'react';
import ProductFilter from './ProductFilter';

function ChatHeader({ languages, selectedLanguage, onLanguageChange, brandConfig, products, selectedProducts, onProductSelectionChange }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Effect to close the dropdown if user clicks outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  return (
    // The main header container: a flexbox row with padding, background, and shadow.
    <header className="flex items-center justify-between w-full p-4 bg-white shadow-md z-10">

      {/* Column 1: The Left Side — product filter */}
      {/* `flex-1` mirrors the right column so the title stays centered. */}
      <div className="flex-1">
        <ProductFilter
          products={products}
          selectedProducts={selectedProducts}
          onSelectionChange={onProductSelectionChange}
        />
      </div>

      {/* Column 2: The Center (Your Title) */}
      {/* `flex-initial` tells it not to grow or shrink. */}
      <div className="flex-initial">
        <h1 className="text-lg font-semibold text-gray-800">
          {brandConfig.supportTitle}
        </h1>
      </div>

      {/* Column 3: Right Side - Language Selector */}
      <div className="flex-1 flex justify-end">
        {selectedLanguage && (
          <div className="relative" ref={dropdownRef}>
            {/* Button showing the currently selected flag */}
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              aria-label="Select language"
            >
              <img
                src={`https://flagcdn.com/w40/${selectedLanguage.ui_flag}.png`}
                alt={`${selectedLanguage.llm_value} flag`}
                className="w-6 h-auto rounded-sm"
              />
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-xl z-20 border border-gray-200">
                <ul className="py-1">
                  {languages.map((lang) => (
                    <li key={lang.ui_flag}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          onLanguageChange(lang);
                          setIsDropdownOpen(false);
                        }}
                        className="flex items-center px-4 py-2 text-sm text-gray-800 hover:bg-gray-100"
                      >
                        <img
                          src={`https://flagcdn.com/w20/${lang.ui_flag}.png`}
                          alt={`${lang.llm_value} flag`}
                          className="w-5 mr-3 rounded-sm"
                        />
                        {/* Capitalize the language name for display */}
                        <span>{lang.llm_value.charAt(0) + lang.llm_value.slice(1).toLowerCase()}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>

    </header>
  );
}

export default ChatHeader;